import { ReactNode } from 'react';
import { View as RNView, StyleProp, ViewStyle } from 'react-native';

interface Props {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
}

export function CardCollectionViewFieldContainer({ children, style }: Props) {
  return <RNView style={style}>{children}</RNView>;
}
